import { type SVGProps } from "react";

const GoogleLogo = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M18.5549 10.3607C18.5549 9.72853 18.4981 9.12066 18.3928 8.53711H9.99609V11.9857H14.7942C14.5875 13.1002 13.9594 14.0444 13.0152 14.6766V16.9135H15.8965C17.5823 15.3614 18.5549 13.0759 18.5549 10.3607Z"
      fill="#4285F4"
    />
    <path
      d="M9.99838 19.075C12.4055 19.075 14.4237 18.2767 15.8988 16.915L13.0175 14.6781C12.2191 15.213 11.1979 15.5291 9.99838 15.5291C7.67632 15.5291 5.71088 13.9608 5.00981 11.8535H2.03125V14.1634C3.49824 17.0771 6.51327 19.075 9.99838 19.075Z"
      fill="#34A853"
    />
    <path
      d="M5.00886 11.854C4.83055 11.3191 4.72924 10.7477 4.72924 10.1601C4.72924 9.57247 4.83055 9.00107 5.00886 8.46615V6.15625H2.03031C1.42649 7.35983 1.08203 8.72145 1.08203 10.1601C1.08203 11.5987 1.42649 12.9603 2.03031 14.1639L5.00886 11.854Z"
      fill="#FBBC05"
    />
    <path
      d="M9.99838 4.79004C11.3073 4.79004 12.4825 5.23986 13.4065 6.1233L15.9636 3.5662C14.4196 2.12758 12.4015 1.24414 9.99838 1.24414C6.51327 1.24414 3.49824 3.242 2.03125 6.15572L5.00981 8.46562C5.71088 6.35834 7.67632 4.79004 9.99838 4.79004Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleLogo;
